import { render, staticRenderFns } from "./CardGroepen.vue?vue&type=template&id=5e8d77c2"
import script from "./CardGroepen.vue?vue&type=script&lang=js"
export * from "./CardGroepen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports